/**
 * TradingView resolveSymbol 的 pricescale（配合 minmov=1）。
 * 刻度步长为 1/pricescale；pricescale=1 时 Y 轴为整数刻度，避免默认两位小数拉宽价格轴。
 * pricePrecision≥3 时仍按市场精度，以免极小价品种刻度失真。
 */
export function getKlineAxisPricescale(pricePrecision: number | undefined | null): number {
  const p =
    pricePrecision !== undefined && pricePrecision !== null && Number.isFinite(pricePrecision) && pricePrecision >= 0
      ? Math.floor(Number(pricePrecision))
      : 2;
  return p <= 2 ? 1 : 10 ** p;
}
